import { useTranslation } from 'next-i18next'

import LoaderSkeleton from '~/shared/components/LoaderSkeleton'
import { OverallProgressCardProps } from '~/statistics-v2/types/statistics.types'

export default function CompletionProgressCard({
  overallProgressCardProps,
  isLoading = false,
}: {
  overallProgressCardProps: OverallProgressCardProps
  isLoading?: boolean
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')

  const { totalTopics, completedTopics, totalSubtopics, completedSubtopics, totalLevels, completedLevels } =
    overallProgressCardProps

  const progressDetails = (type: string, completed: number, total: number): React.ReactElement => (
    <div className="flex justify-between">
      <p className="text-green-lime text-xs">{type}</p>
      <p className="text-sm font-bold text-white">
        {completed} / {total}
      </p>
    </div>
  )

  return (
    <div className="relative h-46 w-full lg:w-125 border rounded-6 border-purple/50 bg-purple-gdark overflow-hidden">
      {isLoading ? (
        <LoaderSkeleton className="absolute min-h-full min-w-full rounded-6 bg-transparent" randomStart speed={1200} />
      ) : (
        <div className="flex flex-col justify-between px-4 py-3">
          <p className="text-white text-sm font-bold leading-8">{t('completion')}</p>

          <div className="flex flex-1 flex-col gap-2 w-full justify-center items-end">
            <div className="flex flex-col gap-2 w-full mt-4">
              {progressDetails(t('topicCompleted'), completedTopics, totalTopics)}
              {progressDetails(t('subtopicCompleted'), completedSubtopics, totalSubtopics)}
              {progressDetails(t('levelsCompleted'), completedLevels, totalLevels)}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
